import React from 'react'

import { StyledSkeleton as S } from './Skeleton.styles'

type TProps = {
  isLoading: boolean
  height: number
  radius?: number
  width?: number
  background?: string
  children?: React.ReactNode
}

export const Skeleton: React.FC<TProps> = ({
  isLoading,
  height,
  radius = 30,
  width,
  background = 'transparent',
  children,
}) => (
  <S.Host $isLoading={isLoading} $height={height} $radius={radius}>
    {children}

    {isLoading && (
      <S.Overlay
        $background={background}
        $radius={radius}
        $height={height}
        $width={width}
      />
    )}
  </S.Host>
)
